import { render, staticRenderFns } from "./CallsSelector.vue?vue&type=template&id=40409137&scoped=true&lang=pug"
import script from "./CallsSelector.vue?vue&type=script&lang=js"
export * from "./CallsSelector.vue?vue&type=script&lang=js"
import style0 from "./CallsSelector.vue?vue&type=style&index=0&id=40409137&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40409137",
  null
  
)

export default component.exports